import axios from 'axios'
import qs from 'querystring'

const errorHandle = (status,info) =>{
    switch(status){
        case 400:
            //console.log("表示请求报文中存在语法错误");
            break;
        case 401:
            //console.log("未经许可，需要通过HTTP认证");
            break;
        case 403:
            //console.log("服务器拒绝该次访问（访问权限出现问题）");
            break;
        case 404:
            //console.log("表示服务器上无法找到请求的资源");
            break;
        case 500:
            //console.log("表示服务器在执行请求时发生了错误");
            break;
        case 503:
            //console.log("表示服务器暂时处于超负载或正在进行停机维护");
            break;
        case 504:
            //console.log("（网关超时）  服务器作为网关或代理，但是没有及时从上游服务器收到请求");
            break;
        default:
            //console.log(info);
            break;
    }
}


const instance = axios.create({
    // baseURL: 'http://iwenwiki.com/',//请求的基本的路径地址
    timeout:5000,
})

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
    if(config.method == 'post'){
        config.data = qs.stringify(config.data)
    }
    return config;
  }, function (error) {
    return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    //console.log('添加响应拦截器',error);
    const { response } = error;
    errorHandle(response.status,response.info)
});

export default instance

